import {Container, Divider, Flex, List, ListItem, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Checkbox} from 'components/shared';
import {ReactNode} from 'react';

interface Props<T> {
  items: {
    value: T;
    label: string | ReactNode;
    disabled?: boolean;
  }[];
  value: T;
  onChange: (value: T) => void;
}

export const CheckboxListBlock = <T extends string>({items, value, onChange}: Props<T>) => {
  if (!items?.length) return null;

  return (
    <Container variant="white-block">
      <List>
        {items.map((item, index) => (
          <ListItem
            key={item.value}
            position="relative"
            sx={{
              _notLast: {
                py: '10px',
              },
              _last: {
                pt: '10px',
              },
            }}
          >
            {index !== 0 && (
              <Divider color={colors.lightGray} position="absolute" top="0" right="0" left="40px" w="unset" />
            )}
            <Checkbox
              variant="circle"
              alignItems="flex-start"
              isChecked={item.value === value}
              isDisabled={item.disabled}
              onChange={() => onChange(item.value)}
            >
              <Flex justifyContent="flex-start" alignItems="center" flexDirection="column">
                <Flex alignItems="center" alignSelf="flex-start">
                  {typeof item.label === 'string' ? (
                    <Text fontSize="16px" fontWeight={600}>
                      {item.label}
                    </Text>
                  ) : (
                    item.label
                  )}
                </Flex>
              </Flex>
            </Checkbox>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};
